import { EINTRAGUNG_ALS_ID, STORAGE_KEY } from 'global/constants';

import { isLocal } from 'utils/StageUtils';

export const shouldMockFachinteressent =
  localStorage.getItem(STORAGE_KEY.MOCK_FACHINTERESSENT) === 'true';

const FACHINTERESSENT_MOCK_ENTRY = {
  id: EINTRAGUNG_ALS_ID.FACHINTERESSENT,
  name: 'Fachinteressent',
};

export const applyFachinteressentMock = (installer) => {
  if (!installer || !shouldMockFachinteressent) {
    return installer;
  }

  return {
    ...installer,
    bEintragungAls: FACHINTERESSENT_MOCK_ENTRY,
    bEintragungGasAls: FACHINTERESSENT_MOCK_ENTRY,
  };
};

if (isLocal() && shouldMockFachinteressent) {
  console.warn('My Data Fachinteressent mock is active');
}
